import { ArrowDownIcon, ArrowUpIcon } from 'lucide-react';

// Filter defaults
// eslint-disable-next-line i18next/no-literal-string -- sentinel compared by the filter hook, which renders a translated label beside it
export const UNCATEGORIZED_TARGET_AUDIENCE = 'Uncategorized';

// Engagement velocity styling
export const EngagementVelocity = {
  peaking: { color: '#04BE6D', icon: ArrowUpIcon },

  accelerating: { color: '#04BE6D', icon: ArrowUpIcon },

  plateauing: { color: '#FF245B', icon: ArrowDownIcon },

  declining: { color: '#FF245B', icon: ArrowDownIcon },
} as const;

export type VelocityKey = keyof typeof EngagementVelocity;
